import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  // scrollBehavior() {
  //   return { x: 0, y: 0 };
  // },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "Brand" */ "../views/index.vue")
      ,
    },
    // {
    //   path: '/school',
    //   name: 'school',
    //   component: () => import(/* webpackChunkName: "Brand" */ "../views/style_three")
    //   ,
    // },
    // {
    //   path: '/ESM',
    //   name: 'ESM',
    //   component: () => import(/* webpackChunkName: "Brand" */ "../views/sty_four")
    //   ,
    // },
    {
      path: '/style1',
      name: 'style1',
      component: () => import(/* webpackChunkName: "Brand" */ "../components/style1.vue")
      ,
    },
    // {
    //   path: '/style2',
    //   name: 'style2',
    //   component: () => import(/* webpackChunkName: "Brand" */ "../components/style2.vue")
    //   ,
    // },
    {
      path: '/village',
      name: 'village',
      component: () => import(/* webpackChunkName: "Brand" */ "../views/sty_five")
      ,
    },
    {
      path: '/success',
      name: 'success',
      component: () => import(/* webpackChunkName: "Brand" */ "../views/success/index.vue")
      ,
    },
    {
      path: '/indoorNavigation',
      name: 'indoorNavigation',
      component: () => import(/* webpackChunkName: "Brand" */ "../views/indoorNavigation")
    },
    {
      path: '/details',
      name: 'successDetails',
      component: () => import(/* webpackChunkName: "Brand" */ "../views/success/details.vue")
      ,
    },
    {
      path: '/newsUpdates',
      name: 'newsUpdates',
      component: () => import(/* webpackChunkName: "Brand" */ "../views/news_updates")
      ,
    },
    {
      path: '/newsUpdates/detail',
      name: 'detail',
      component: () => import(/* webpackChunkName: "Brand" */ "../views/news_updates/detail.vue")
      ,
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import(/* webpackChunkName: "Brand" */ "../views/aboutUs")
      ,
    },
    {
      path: '/bigView',
      name: 'bigView',
      component: () => import(/* webpackChunkName: "Brand" */ "../views/bigView")
      ,
    },
    // {
    //   path: '/backHome',
    //   name: 'backHome',
    //   component: BackHome
    // }
  ]
})
// router.beforeEach((to, from, next) => {
//   if (to = from) {
//     location.reload()
//   }
//   next()
// });
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router


// WEBPACK FOOTER //
// ./src/router/index.js